const mathAnxietyData = {
  qs: [
    "My child cringes when they have to go to math class.",
    "My child gets nervous about going to the board during math class.",
    "My child’s mind wanders during math class.",
    "My child is afraid of math tests more than any other subject.",
    "My child understands math in class but forgets how to do it when they get home.",
    "My child is always worried that they will get called on in math class.",
    "My child feels that they are less capable of doing well in math than their classmates.",
    "My child is afraid to ask questions in math class.",
    "My child feels that they will never use what they are learning in math class in the real world.",
    "My child is afraid that they will not be able to keep up with the rest of the class.",
  ],
  opts: {
    "Strongly Agree": 5,
    Agree: 3,
    Neutral: 0,
    Disagree: -3,
    "Strongly Disagree": -5,
  },
  s: {
    anxiety: {
      title: "MATH MAKES YOUR CHILD REALLY NERVOUS!",
      p1: "For your child, math causes a lot of anxiety, frustration, and confusion.  Math does not come easy and may often seem out of reach to them.  Some of the symptoms of math anxiety are nervousness, lack of confidence, tears or anger when trying to do math, difficulty concentrating, an avoidance of math, and an inferiority and permanence regarding math abilities.",
      subtitle1: "WHAT MATH ANXIETY CAN SOUND LIKE:",
      cl: [
        "I hate math and I wish it never existed!",
        "I feel stupid and I can’t do it.",
        "Math is too hard!",
        "Math is boring.",
        "I’ll never use math in the real-world.",
        "I’m not a math person.",
      ],
      subtitle2: "HOW CAN GROWING IQ HELP?",
      p2: "We help our students become more confident in themselves and their abilities so that self-doubt will not hinder their road to success by:",
      hl: [
        "Making math fun!",
        "Providing a positive and safe learning environment.",
        "Helping students understand the “why” of mathematics.",
        "Using positive reinforcement to help students succeed.",
        "Allowing students time to think.",
        "Changing math into a low-risk activity.",
      ],
    },
    lover: {
      title: "YOUR CHILD IS A MATH LOVER!",
      p1: "For your child, math class is fun, and they enjoy the challenges that it presents.  We are all born being excited by math (as young children counting items, rearranging things, or sorting blocks just to name a few).  Many people lose that excitement along the way, but your child has maintained a fascination with math.  This does not mean that everything in math class comeseasy, but they are not intimidated, and they are up to the challenge.",
      subtitle1: "CHARACTERISTICS OF HIGHLY ABLE MATH STUDENTS:",
      cl: [
        "Perceives, visualizes, and generalizes numeric and non-numeric patterns and relationships.",
        "Takes risks with math concepts and strategies.",
        "Has a keen awareness of quantitative information in the world around them.",
        "Reasons analytically, deductively, and inductively.",
        "Solves problems with multiple and alternative solutions.",
      ],
      subtitle2: "HOW CAN GROWING IQ PROGRESS YOUR CHILD EVEN FURTHER?",
      p2: "For promising mathematics students, their abilities are not fixed and need continued development and fostering so that their potential can be maximized. We help our math loving students by:",
      hl: [
        "Making math challenging and fun!",
        "Placing students in classes by ability and not by grade.",
        "Meeting their unique pace and depth needs.",
        "Allowing experimentation with mathematics.",
        "Helping students to see and develop different ways of solving problems.",
        "Nurturing the special way they think.",
      ],
    },
    fence: {
      title: "YOUR CHILD IS SITTING ON THE MATH FENCE!",
      p1: "For your child, math is a subject that they do not have strong feelings about either way. It may not be their favorite, but it is not their worse subject either. Research suggests that emotions have a real impact on a student's math performance over time. So, a student who is indifferent to math may find less motivation and therefore sabotage their math progress in the long run.",
      subtitle1: "SOME OF THE CAUSES OF MATH INDIFFERENCE:",
      cl: [
        "Math is difficult to relate to because it is abstract.",
        "There is only a right or a wrong answer.",
        "There is an expectation that it is supposed to be difficult.",
        "Math has a reputation of being boring.",
        "Math is taught using repetition.",
      ],
      subtitle2: "HOW CAN GROWING IQ TURN YOUR CHILD INTO A MATH LOVER?",
      p2: "The good news about the common causes of math indifference, is that they are all misconceptions.  Given the right experiences and the right learning environment, a child that is “maah” about math can end up discovering that they actually have a great love for it! We help our indifferent students by:",
      hl: [
        "Immersing students in a fun environment!",
        "Actively engaging students in mathematical experiences.",
        "Making math more tangible.",
        "Focusing on the process not the answer.",
        "Showing that math provides opportunities to continue to grow skills.",
        "Helping them to see that math is not just about numbers.",
      ],
    },
  },
};

export { mathAnxietyData };
